var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('live-eks')],1)}
var staticRenderFns = []

export { render, staticRenderFns }